import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconWheelhouseRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
    <rect x="0.899902" y="0.5" width="23" height="23" rx="5.5" fill="white" />
    <rect x="0.899902" y="0.5" width="23" height="23" rx="5.5" stroke="#E9EEF1" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.02235 6.35671L9.30389 17.6743C9.39371 17.8668 9.66723 17.8673 9.75781 17.6752L12.0022 12.9148L14.6583 18.5522C14.7489 18.7444 15.0225 18.7439 15.1123 18.5513L20.7992 6.35665C20.8768 6.19045 20.7554 6 20.572 6H15.2624L12.0022 12.9148L8.7443 6H4.24952C4.06611 6 3.94479 6.1905 4.02235 6.35671Z"
      fill="#D134CD"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.2627 6H8.74463L12.0025 12.9147L15.2627 6Z"
      fill="#8D1F8F"
    />
  </svg>
)

export const IconWheelhouseRectangle = forwardRef(_IconWheelhouseRectangle)
